import React, { useEffect, useState } from 'react'
import HeaderBar from '../../HeaderBar'
import { Box, Button, Grid, Paper, Typography } from '@mui/material'
import { containerStyle, imgContainer, imgStyle } from '../../formStyle'
import WORKslogans from '../../WORKslogans'
import { useNavigate } from 'react-router-dom'
import Loader from '../../Loader'
import { fetchWORKersTasks } from '../../../backend/backendApis'
import HttpService from '../../../backend/requestApis'
import { buttonStyle, errorTextStyle } from '../../../utils/commonCSS'
import { amber, green, headingBlue, maroon, mediumGrey, pureWhite } from '../../../assets/colors'
import { tableOffsets2, taskTypeList } from '../../../utils/constants'
import { KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material'
import CustomDropDown from '../../CustomDropDown'
import TaskDetailsDialog from './TaskDetailsDialog'

const WORKersTask = () => {
  const navigate = useNavigate()

	const [loader, setLoader] = useState(false)
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
	const [page, setPage] = useState(1)
	const [offset, setOffset] = useState(10)
	const [totalRecords, setTotalRecords] = useState(0)
	const [totalPages, setTotalPages] = useState(0)
	const [tasksData, setTasksData] = useState([])
	const [isRefresh, setIsRefresh] = useState(false)
	const [errorMessage, setErrorMessage] = useState('')
	const [detailDialogStatus, setDetailDialogStatus] = useState(false)
	const [selectedData, setSelectedData] = useState({})

	const updatePage = (opt) => {
		if( page === 1 && opt === 'dec'){
			setPage(1)
		} else if(page === totalPages && opt === 'inc'){
			setPage(totalPages)
		} else if( opt === 'dec'){
			setPage(page -1)
		} else {
			setPage(page + 1 )
		}
		setIsRefresh(!isRefresh)
	}

	const updateOffset = (offset) => {
		setOffset(offset)
		setPage(1)
		setIsRefresh(!isRefresh)
	}

	const updateDetailDialogStatus = (value, refresh= false) => {
		setDetailDialogStatus(() => value)
		if(refresh){
			setIsRefresh(() => !isRefresh)
		}
	}

	useEffect(() => {
		setLoader(() => true)
		let options = {
			url: fetchWORKersTasks,
			method: 'GET',
			params: {
				page: page,
				offset: offset
			},
			headers: {
				Authorization: localStorage.getItem('token') ? `Bearer ${localStorage.getItem('token')}` : null
			}
		}
		HttpService(options).then(resp => {
				setTotalRecords(resp?.data?.data?.totalRecords)
				setTotalPages(resp?.data?.data?.totalPages)
				setTasksData(resp?.data?.data?.records)
				setLoader(false)
		}).catch(err => {
				if (err?.status === 403) {
					localStorage.clear()
					navigate('/signUp')
					setLoader(false)  
				} else {
					console.log('Error in fetching the WORKer tasks: ', err)
					setErrorMessage('Error in Fetching Tasks. Please Contact Support.')
					setLoader(false)
				}
				
		})

	}, [isRefresh])

  return (
    <>
        <HeaderBar isReportForm={true}></HeaderBar>
        <Box style={{...containerStyle, maxWidth: "28rem"}}>
            <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <WORKslogans></WORKslogans>
            </Box>
            <Box style={{...imgContainer}}>
								<img src={require("../../../assets/images/WORK_logo.png")}
                    alt='Logo'
                    style={{...imgStyle}}
                    onClick={() => navigate('/signUp')}
                >
                </img>
            </Box>

						<Typography style={{ fontSize: "1.2rem", fontWeight: 600, padding: "0.1rem 0.3rem 0.1rem 0.5rem" }}>Tasks</Typography>

						<Paper style={{
								// maxHeight: '55vh',
								height: '55vh',
								overflowY: "auto",
								padding: '0rem 0.2rem 0rem 0.2rem',
								scrollbarWidth: "none",
								border: '1px solid #D3D3D3'
						}}>
							{loader && <Loader></Loader>}
							<Box style={{height: isMobile ? '43vh' : '47vh', overflow: 'auto', scrollbarWidth: "none",
								padding: '0.5rem 0rem 0.5rem 0rem'
							}}>
								{
									tasksData?.length > 0 ?
									(tasksData?.map((task) => (
										<Box onClick={() => {
											setSelectedData(task)
											updateDetailDialogStatus(true)}}>
											<TaskRow task={task} isMobile={isMobile}></TaskRow>
										</Box>
									))) : 
									<Box style={{display: 'flex', justifyContent: 'center', marginTop: '2rem'}}>
									{errorMessage != '' ?
									<Typography style={{...errorTextStyle, fontSize: '1rem'}}>{errorMessage}</Typography>:
									<Typography style={{...errorTextStyle, fontSize: '1.2rem', color: headingBlue}}>No Tasks</Typography>
									}
									</Box>
								}
							</Box>

							<Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0.4rem 0.3rem 0rem 0.3rem'}}>
                  <Grid container spacing = {1} style={{display: 'flex', justifyContent: 'center', alignItems:'center'}}>
                    <Grid item xs={3} sm={3}>
                      <Typography style={{color: maroon}} sx={{ fontSize: isMobile ? "0.8rem" : "0.9rem" }}>
                        {`${totalRecords ? (page - 1) * offset + 1 : 0} - ${(page * offset) < totalRecords ? (page * offset) : (totalRecords ? totalRecords : 0)}  of ${totalRecords ? totalRecords : 0}`}</Typography>
                    </Grid>
                    <Grid item xs={6} sm={6}>
                      <Box style={{display: 'flex', justifyContent: 'center'}}>
                        {page === 1 ?
                          <>
                            <Box style={{opacity: 0.5, PointerEvent: 'none'}}>
                              <KeyboardArrowLeft></KeyboardArrowLeft>
                            </Box>
                            
                          </>
                           :
                          <KeyboardArrowLeft style={{color: headingBlue}} onClick={() => {
                            updatePage('dec')
                          }}></KeyboardArrowLeft>
                        }
                        
                        <Typography 
                          sx={{ fontSize: isMobile ? "0.8rem" : "0.9rem" }}
                          style={{display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: headingBlue, color: pureWhite, padding: '0.3rem', width: '1rem', height: '1rem', borderRadius: '50%'}}>
                            {page}
                          </Typography>
                        {(!totalPages || page === totalPages) ?
                          <Box style={{opacity: 0.5, PointerEvent: 'none'}}> 
                            <KeyboardArrowRight></KeyboardArrowRight> 
                          </Box>
                            : 
                          <KeyboardArrowRight
                            onClick={() => {
                              updatePage('inc')
                            }}
                          ></KeyboardArrowRight>
                        }
                        
                      </Box>
                    </Grid>
                    <Grid item xs={3} sm={3} >
                      <Box style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                        <CustomDropDown list ={tableOffsets2} value={offset} 
												setFunc={updateOffset}
												></CustomDropDown>
                      </Box>

                    </Grid>

                  </Grid>
              </Box>
							
						</Paper>

        </Box>

			<TaskDetailsDialog dialogStatus = {detailDialogStatus} updateDialogStatus={updateDetailDialogStatus} data={selectedData}></TaskDetailsDialog>
    </>
  )
}

function TaskRow({task, isMobile}){
	return(
		<>
			<Box style={{padding: '0.25rem 0.15rem 0.25rem 0.15rem', border: `1px solid ${mediumGrey}`, marginBottom: '0.15rem'}}>
				<Grid container spacing={1} style={{padding: '0.1rem 0.3rem 0.1rem 0.3rem'}}>
					<Grid item xs={3} sm ={3} style={{display: 'flex', alignItems: 'center'}}>
              <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: headingBlue }}>
                {task.taskTitle}
              </Typography>
            </Grid>
						<Grid item xs={3} sm ={3} style={{display: 'flex', alignItems: 'center'}}>
              <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: headingBlue }}>
                {(taskTypeList.find((e) => e.value === task.taskCategory)).name }
              </Typography>
            </Grid>
						<Grid item xs={3} sm ={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
              <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: headingBlue }}>
                {task.assignedDate?.split('T')[0]} <br></br>
								{(task.assignedDate?.split('T')[1]).split('.')[0]}
              </Typography>
            </Grid>
						<Grid item xs={3} sm ={3} style={{display: 'flex', alignItems: 'center', justifyContent: 'flex-end'}}>
              {/* <Typography  sx={{ wordBreak: "break-word", minWidth: 0, fontSize: isMobile ? "0.9rem" : "1rem", color: headingBlue }}> */}
								<Button style={{...buttonStyle, width: '4.5rem', height: '1.75rem', fontSize: '0.8rem', backgroundColor: task?.taskStatus === 'done' ? green : amber}}>
									{ task?.taskStatus === 'done' ? 'Done' : 'Pending'}
								</Button>
              {/* </Typography> */}
            </Grid>
				</Grid>
			</Box>
		</>
	)
}

export default WORKersTask
